// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__p8+Ae","lastLink":"HeadPage_lastLink__vcDTX"};